module.exports = __webpack_public_path__ + "img/time@2x.3799b64.jpg";